import { BandwidthAssetRisk } from "@core/models/bandwidth-asset-risk.model";
import { Composition } from "@core/models/composition.model";
import { FundComposition } from "@core/models/fund-composition.model";

export class CompositionModelHelper {
  static addModelVersionId(
    array: Array<FundComposition | BandwidthAssetRisk>,
    compositionModelVersionId: string
  ): Array<FundComposition | BandwidthAssetRisk> {
    return array.map(
      (
        element: FundComposition | BandwidthAssetRisk
      ): FundComposition | BandwidthAssetRisk => ({
        ...element,
        compositionModelVersionId,
      })
    );
  }

  static checkRiskProfileExistence(
    riskProfileId: string,
    productId: string,
    compositionList: Array<Composition>
  ): boolean {
    if (productId) {
      return !!compositionList.find(
        (composition: Composition): boolean =>
          composition.gfhProduct.id === productId &&
          composition.riskProfile.id === riskProfileId
      );
    }
    return false;
  }
}
